import { render, staticRenderFns } from "./AntonymsRussianLanguage.vue?vue&type=template&id=55aed07a&lang=pug&"
import script from "./AntonymsRussianLanguage.vue?vue&type=script&lang=js&"
export * from "./AntonymsRussianLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports